import React from 'react';
import { Link } from 'react-router-dom';
import { Menu } from 'antd';
import { SettingOutlined } from '@ant-design/icons';
import SubMenuIndexes from 'modules/layoutModule/enums/SubMenuIndexes';
import MenuIndexes from 'modules/layoutModule/enums/MenuIndexes';
import {
  contentSettingsModulesList,
  ContentSettingsSubModuleDefinition,
  ModulesDefinition,
  settingsModulesList,
  SettingsSubModuleDefinition,
} from 'enums/modulesDefinition';

const { SubMenu } = Menu;

export const ContentMenuTab = (
  subMenuClick: any,
  setSelectedMenu: any,
  subModulesData: any,
  title: string,
  userModules: any[]
) => {
  const renderSubModules = (el: any) => {
    switch (el.id) {
      case ContentSettingsSubModuleDefinition.newsCategoriesAdd:
        return (
          <Menu.Item
            key={MenuIndexes.NEWS_CATEGORY_ADD}
            onClick={(e) => setSelectedMenu([e.key])}
          >
            <Link to="/news/categories/add">{el.title}</Link>
          </Menu.Item>
        );
      case ContentSettingsSubModuleDefinition.newsCategoriesList:
        return (
          <Menu.Item
            key={MenuIndexes.NEWS_CATS}
            onClick={(e) => setSelectedMenu([e.key])}
          >
            <Link to="/news/categories">{el.title}</Link>
          </Menu.Item>
        );
      case ContentSettingsSubModuleDefinition.allCategoriesAdd:
        return (
          <Menu.Item
            key={MenuIndexes.ALL_CATEGORY_ADD}
            onClick={(e) => setSelectedMenu([e.key])}
          >
            <Link to="/all-categories/add">{el.title}</Link>
          </Menu.Item>
        );
      case ContentSettingsSubModuleDefinition.sectionsAdd:
        return (
          <Menu.Item
            key={MenuIndexes.SECTION_ADD}
            onClick={(e) => setSelectedMenu([e.key])}
          >
            <Link to="/sections/add">{el.title}</Link>
          </Menu.Item>
        );
      case ContentSettingsSubModuleDefinition.sectionsList:
        return (
          <Menu.Item
            key={MenuIndexes.SECTION_LIST}
            onClick={(e) => setSelectedMenu([e.key])}
          >
            <Link to="/sections">{el.title}</Link>
          </Menu.Item>
        );
      case ContentSettingsSubModuleDefinition.allCategoriesList:
        return (
          <Menu.Item
            key={MenuIndexes.ALL_CATEGORY_LIST}
            onClick={(e) => setSelectedMenu([e.key])}
          >
            <Link to="/all-categories">{el.title}</Link>
          </Menu.Item>
        );
      case ContentSettingsSubModuleDefinition.fertilizersCategoriesAdd:
        return (
          <Menu.Item
            key={MenuIndexes.FERTILIZERS_CATEGORIES_ADD}
            onClick={(e) => setSelectedMenu([e.key])}
          >
            <Link to="/fertilizers/categories/add">{el.title}</Link>
          </Menu.Item>
        );
      case ContentSettingsSubModuleDefinition.fertilizersCategories:
        return (
          <Menu.Item
            key={MenuIndexes.FERTILIZERS_CATEGORIES}
            onClick={(e) => setSelectedMenu([e.key])}
          >
            <Link to="/fertilizers/categories">{el.title}</Link>
          </Menu.Item>
        );
      case ContentSettingsSubModuleDefinition.fertilizersPackAdd:
        return (
          <Menu.Item
            key={MenuIndexes.FERTILIZERS_PACK_ADD}
            onClick={(e) => setSelectedMenu([e.key])}
          >
            <Link to="/fertilizers/pack/add">{el.title}</Link>
          </Menu.Item>
        );
      case ContentSettingsSubModuleDefinition.fertilizersPack:
        return (
          <Menu.Item
            key={MenuIndexes.FERTILIZERS_PACK}
            onClick={(e) => setSelectedMenu([e.key])}
          >
            <Link to="/fertilizers/pack">{el.title}</Link>
          </Menu.Item>
        );
      case ContentSettingsSubModuleDefinition.gtwCatAdd:
        return (
          <Menu.Item
            key={MenuIndexes.GTW_CAT_ADD}
            onClick={(e) => setSelectedMenu([e.key])}
          >
            <Link to="/gtw-categories/add">{el.title}</Link>
          </Menu.Item>
        );
      case ContentSettingsSubModuleDefinition.gtwCat:
        return (
          <Menu.Item
            key={MenuIndexes.GTW_CAT}
            onClick={(e) => setSelectedMenu([e.key])}
          >
            <Link to="/gtw-categories">{el.title}</Link>
          </Menu.Item>
        );
      default:
        return null;
    }
  };

  const checkPermissions = contentSettingsModulesList.filter((module) => {
    if (userModules.includes(module.id)) return module;
  });

  if (checkPermissions.length === 0) {
    return <></>;
  }

  return (
    <SubMenu
      key={SubMenuIndexes.CONTENT_SETTINGS}
      icon={<SettingOutlined />}
      title={title}
      onTitleClick={(e) => subMenuClick(e)}
    >
      {checkPermissions.map((module) => renderSubModules(module))}
    </SubMenu>
  );
};
